import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import { useParams, Link } from "react-router-dom";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const Veh_transfer_history_report = () => {
  useAuthRedirect();
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(localStorage.getItem("branch") || "");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState(""); 

  const canView  = hasPermission("Vehicle Transferring Report", "view");


  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [transferRes, positionRes] = await Promise.all([
          axios.get(`https://rfs2.infraconsoft.net.in/api/veh_transfer_history_report?vCode=${id}`),
          axios.get(`https://rfs2.infraconsoft.net.in/api/veh_position_summary?vCode=${id}`)
        ]);

        const transfers = transferRes.data;
        const positions = positionRes.data;

        // Build cumulative array of position data
        let cumulative = [];
        let hrs = 0, km = 0;
        for (let pos of positions) {
          hrs += parseFloat(pos.fld_wohrs || 0);
          km += parseFloat(pos.fld_wokm || 0);
          cumulative.push({
            date: new Date(pos.fld_vdate),
            totalHrs: hrs,
            totalKm: km
          });
        }

        const findNearestTotal = (targetDate) => {
          let prev = { totalHrs: 0, totalKm: 0 };
          for (let entry of cumulative) {
            if (entry.date <= targetDate) {
              prev = entry;
            } else {
              break;
            }
          }
          return prev;
        };

        const finalResults = transfers.map((row, i) => {
          const fromDate = row.fld_approved_time ? new Date(row.fld_approved_time) : null;
          const fromStr = fromDate ? fromDate.toLocaleDateString("en-GB") : "-";

          let toDate = null;
          for (let j = i + 1; j < transfers.length; j++) {
            if (transfers[j].fld_transfer_from === row.fld_transfer_to) {
              toDate = new Date(transfers[j].fld_transfer_time);
              break;
            }
          }
          const toStr = toDate ? toDate.toLocaleDateString("en-GB") : "-";

          const startTotals = fromDate ? findNearestTotal(fromDate) : { totalHrs: 0, totalKm: 0 };
          const endTotals = toDate ? findNearestTotal(toDate) : cumulative.length > 0
            ? cumulative[cumulative.length - 1]
            : { totalHrs: 0, totalKm: 0 };

          const wrkHr = endTotals.totalHrs - startTotals.totalHrs;
          const wrkKm = endTotals.totalKm - startTotals.totalKm;

          return {
            SlNo: i + 1,
            site: row.fld_transfer_to,
            fromDate: fromStr,
            toDate: toStr,
            stHrs: startTotals.totalHrs.toFixed(2),
            stKm: startTotals.totalKm.toFixed(2),
            endHrs: endTotals.totalHrs.toFixed(2),
            endKm: endTotals.totalKm.toFixed(2),
            wrkHr: wrkHr.toFixed(2),
            wrkKm: wrkKm.toFixed(2)
          };
        });

        setData(finalResults);
        setFilteredData(finalResults);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

   // Handle page change
   const paginate = (pageNumber) => setCurrentPage(pageNumber);

   // Calculate indexes for pagination
   const indexOfLastItem = currentPage * itemsPerPage;
   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
   const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
  
    if (term === "") {
      setFilteredData(data);
      return;
    }
  
    const filtered = data.filter((item) =>
      (String(item.site || "").toLowerCase().includes(term))
    );
  
    setFilteredData(filtered);
  };

  const [site, setSite] = useState({
  ok: true,
  name: "Infraconsoft",
  logo: null,
  address: "",
  email: "",
  phone: "",
  _ts: 0,
});

useEffect(() => {
  let ignore = false;
  (async () => {
    try {
      const res = await axios.get("https://rfs2.infraconsoft.net.in/api/siteinfo");
      const s = res?.data || {};
      let logo = s.logo || null;
      if (logo && !/^https?:\/\//i.test(logo)) {
        if (!logo.startsWith("/")) logo = `/${logo}`;
        logo = `${window.location.origin}${logo}`;
      }
      if (!ignore) {
        setSite({
          ok: !!s.ok,
          name: s.name || "Infraconsoft",
          logo,
          address: s.address || "",
          email: s.email || "",
          phone: s.phone || "",
          _ts: Date.now(),
        });
      }
    } catch (e) {
      console.error("Failed to load /siteinfo", e);
    }
  })();
  return () => {
    ignore = true;
  };
}, []);


  // inside your component
const exportToExcel = () => {
  // 1️⃣ Prepare table data
  const exportData = filteredData.map(item => ({
    "S.No": item.SlNo,
    "Name Of Site": item.site,
    "From Date": item.fromDate,
    "Start Hour": item.stHrs,
    "Start Km": item.stKm,
    "To Date": item.toDate,
    "End Hour": item.endHrs,
    "End Km": item.endKm,
    "Site Working Hr": item.wrkHr,
    "Site Working Km": item.wrkKm,
  }));

  // 2️⃣ Keep column order and prepare AOA (array of arrays)
  const headers = exportData.length
    ? Object.keys(exportData[0])
    : [
        "S.No",
        "Name Of Site",
        "From Date",
        "Start Hour",
        "Start Km",
        "To Date",
        "End Hour",
        "End Km",
        "Site Working Hr",
        "Site Working Km",
      ];

  const dataRows = exportData.map(row => headers.map(h => row[h] ?? ""));

  // 3️⃣ Company Header + Title (merged across all columns)
  const COLS = headers.length;
  const fullWidth = (text = "") => [text, ...Array(COLS - 1).fill("")];

  const titleBits = ["Vehicle Transfer History"];
  if (id) titleBits.push(`Vehicle ID: ${id}`);
  const title = titleBits.join(" — ");

  const aoa = [
    fullWidth((site.name || "Infraconsoft").toUpperCase()),
    fullWidth(site.address || ""),
    fullWidth(
      [site.phone ? `Ph: ${site.phone}` : "", site.email ? `Email: ${site.email}` : ""]
        .filter(Boolean)
        .join(" | ")
    ),
    [], // spacer
    fullWidth(title),
    [], // spacer
    headers,
    ...dataRows,
  ];

  // 4️⃣ Create Worksheet
  const ws = XLSX.utils.aoa_to_sheet(aoa);

  // Merge top rows
  ws["!merges"] = [
    { s: { r: 0, c: 0 }, e: { r: 0, c: COLS - 1 } }, // Company Name
    { s: { r: 1, c: 0 }, e: { r: 1, c: COLS - 1 } }, // Address
    { s: { r: 2, c: 0 }, e: { r: 2, c: COLS - 1 } }, // Phone/Email
    { s: { r: 4, c: 0 }, e: { r: 4, c: COLS - 1 } }, // Title
  ];

  // Set sensible column widths
  const widthMap = {
    "S.No": 6,
    "Name Of Site": 22,
    "From Date": 14,
    "Start Hour": 12,
    "Start Km": 12,
    "To Date": 14,
    "End Hour": 12,
    "End Km": 12,
    "Site Working Hr": 14,
    "Site Working Km": 14,
  };
  ws["!cols"] = headers.map(h => ({ wch: widthMap[h] || 12 }));

  // Freeze after header block
  ws["!freeze"] = { xSplit: 0, ySplit: 6, topLeftCell: "A7", activePane: "bottomLeft" };

  // 5️⃣ Build Workbook and Download
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Transfer History");

  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
  });

  saveAs(blob, `Vehicle_Transfer_History_${id || "All"}.xlsx`);
};


   if (!canView) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          
           <div className="back-div">
                                <h2 className="add-txt">Vehicle Transfering - History</h2>
                                <Link to={`/vehicle_transfering_list`}><p className="back-button"><i className="fa-solid fa-backward"></i> Back</p></Link>
                                </div>
          <div><Time /></div>
        </section>

        <div className="add-new-container">
          <button className="add-new-btn" onClick={exportToExcel}>
            <i className="fa-solid fa-file-excel"></i> Export to Excel
          </button>
        </div>

        <div className="search-filter">
          <p>Search: </p>
          <input type="text" placeholder="Search by Site Name" value={searchTerm} onChange={handleSearch} className="search-input" />
        </div>

        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Name Of Site</th>
                <th>From Date</th>
                <th>S.Hour</th>
                <th>S.Km</th>
                <th>To Date</th>
                <th>C.Hour</th>
                <th>C.Km</th>
                <th>Site Working Hr</th>
                <th>Site Working Km</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="10" className="loading-text">Loading data, please wait...</td>
                </tr>
              ) : currentData.length > 0 ? (
                currentData.map((item, index) => (
                  <tr key={index}>
                    <td>{item.SlNo}</td>
                    <td>{item.site}</td>
                    <td>{item.fromDate}</td>
                    <td>{item.stHrs}</td>
                    <td>{item.stKm}</td>
                    <td>{item.toDate}</td>
                    <td>{item.endHrs}</td>
                    <td>{item.endKm}</td>
                    <td>{item.wrkHr}</td>
                    <td>{item.wrkKm}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="10">No Data Available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
            Previous
          </button>

          {/* Always show first page */}
          <button onClick={() => paginate(1)} className={currentPage === 1 ? 'active' : ''}>
            1
          </button>

          {/* Show up to 3 pages dynamically */}
          {filteredData.length > 0 &&
            [...Array(Math.min(3, Math.ceil(filteredData.length / itemsPerPage) - 1))].map((_, index) => {
              const pageNumber = currentPage + index;
              if (pageNumber > 1 && pageNumber <= Math.ceil(filteredData.length / itemsPerPage)) {
                return (
                  <button key={pageNumber} onClick={() => paginate(pageNumber)} className={currentPage === pageNumber ? 'active' : ''}>
                    {pageNumber}
                  </button>
                );
              }
              return null;
            })
          }

          {/* Next button */}
          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default Veh_transfer_history_report;
